import { CartProductsSchema } from 'src/models/cart/CartProductsSchema';
import { CartItem } from 'src/models/orderLimits/schema';
import { Left, Right } from 'src/utils/either';
import { errorMessage } from 'src/utils/errorMessage';
import { shoppingApiBaseUrl } from 'src/utils/shoppingApiBaseUrl';
import { getLocaleFromUrl } from 'src/utils/subdomain';
import { deleteRequest, getRequest, postRequest } from '../wa/gateways/api/wamazingApi';
import { ApiResponse } from './response/ApiResponse';

type CartResponse = {
  shopId: number;
  cart: {
    products: CartProductsSchema[];
  };
};

const fetchCart = async (): Promise<ApiResponse<CartResponse>> => {
  try {
    const response = await getRequest<CartResponse>({
      baseURI: shoppingApiBaseUrl(getLocaleFromUrl()),
      path: '/api/v1/carts',
    });
    return new Right(response);
  } catch (e) {
    return new Left({ errors: [errorMessage(e)] });
  }
};

type CartQuantityResponse = { cartTotalQuantity: number };

const fetchCartQuantity = async (): Promise<ApiResponse<CartQuantityResponse>> => {
  try {
    const response = await getRequest<CartQuantityResponse>({
      baseURI: shoppingApiBaseUrl(getLocaleFromUrl()),
      path: '/api/v1/carts/total_quantity',
    });
    return new Right(response);
  } catch (e) {
    return new Left({ errors: [errorMessage(e)] });
  }
};

const postCart = async (shopId: number, cart: CartItem[]): Promise<ApiResponse<CartItem[]>> => {
  try {
    await postRequest({
      baseURI: shoppingApiBaseUrl(getLocaleFromUrl()),
      path: '/api/v1/carts',
      params: { shopId, cart },
    });
    return new Right(cart);
  } catch (e) {
    return new Left({ errors: [errorMessage(e)] });
  }
};

const deleteCart = async (): Promise<ApiResponse<boolean>> => {
  try {
    await deleteRequest({
      baseURI: shoppingApiBaseUrl(getLocaleFromUrl()),
      path: '/api/v1/carts',
    });
    return new Right(true);
  } catch (e) {
    return new Left({ errors: [errorMessage(e)] });
  }
};

export { deleteCart, fetchCart, postCart, fetchCartQuantity };
